export const blockIconsFileCloudUpload = (
	<span className='material-symbols-outlined'>cloud_upload</span>
);
